import { all, fork, type AllEffect, type ForkEffect } from 'redux-saga/effects';
import appSagas from './app/saga';
import authSagas from './auth/saga';
import campaignsSagas from './campaigns/saga';
import contactsSagas from './contacts/saga';
import emailsSaga from './emails/saga';
import emailTemplatesSaga from './emailTemplates/saga';
import groupsSagas from './groups/saga';
import pointageSagas from './pointage/saga';
import rolesSagas from './roles/saga';
import smsSagas from './sms/saga';
import sourceEmailsSagas from './sourceEmails/saga';
import sourcePhoneNumbersSagas from './sourcePhoneNumbers/saga';
import tagsSagas from './tags/saga';
import usersSagas from './users/saga';

import {
  createCallsSaga,
  createContactsSaga,
  createEmailsSaga,
  createSmsSaga,
} from './nestedRestSlice/saga';
import {
  createCallsSelectors,
  createContactsSelectors,
  createEmailsSelectors,
  createSmsSelectors,
} from './nestedRestSlice/selectors';

export const emailsSelectors = createEmailsSelectors('campaigns');
export const smsSelectors = createSmsSelectors('campaigns');

export default function* rootSaga(): Generator<AllEffect<ForkEffect<void>>, void, unknown> {
  yield all([
    fork(appSagas),
    fork(authSagas),
    fork(campaignsSagas),
    fork(contactsSagas),
    fork(emailsSaga),
    fork(emailTemplatesSaga),
    fork(groupsSagas),
    fork(pointageSagas),
    fork(rolesSagas),
    fork(smsSagas),
    fork(sourceEmailsSagas),
    fork(sourcePhoneNumbersSagas),
    fork(tagsSagas),
    fork(usersSagas),
    fork(createContactsSaga('campaigns', createContactsSelectors('campaigns'))),
    fork(createCallsSaga('campaigns', createCallsSelectors('campaigns'))),
    fork(createEmailsSaga('campaigns', emailsSelectors)),
    fork(createSmsSaga('campaigns', smsSelectors)),
    fork(createContactsSaga('groups', createContactsSelectors('groups'))),
    fork(createCallsSaga('groups', createCallsSelectors('groups'))),
  ]);
}
